import { CSSProperties } from 'react'
export type GridPosition = Pick<CSSProperties, 'gridColumnStart' | 'gridColumnEnd' | 'gridRowStart' | 'gridRowEnd'>

export interface HexElementClassNames {
  button: string
  text: string
}

export interface HexElementProperties {
  color: string
  classNames: HexElementClassNames
  gemstoneOutlineColor?: 'black' | 'white'
  i18nKey: 'go' | 'playAlt'
  splat?: 'left' | 'right'
}

export const DRILL_TOPIC = {
  BASIC_ALGEBRA_EN: { path: 'basic-algebra', title: 'Basic Algebra' },
  BASIC_ALGEBRA_NB: { path: 'bokstavregning', title: 'Bokstavregning' },
  BASIC_ALGEBRA_UA: { path: 'osnovy-alhebry', title: 'Основи алгебри' },
  EQUATIONS_EN: { path: 'equations', title: 'Equations' },
  EQUATIONS_NB: { path: 'likninger', title: 'Likninger' },
  EQUATIONS_UA: { path: 'rivnyannya', title: 'Рівняння' },
  FACTORIZATION_EN: { path: 'algebraic-factorization', title: 'Algebraic Factorization' },
  FACTORIZATION_NB: { path: 'algebraisk-faktorisering', title: 'Algebraisk Faktorisering' },
  FACTORIZATION_UA: { path: 'rozkladannya-mnohochlena-na-mnozhnyky', title: 'Розкладання многочлена на множники' },
  FRACTIONS_EN: { path: 'fractions', title: 'Fractions' },
  FRACTIONS_NB: { path: 'brok', title: 'Brøk' },
  FRACTIONS_UA: { path: 'droby', title: 'Дроби' },
  FUNCTIONS_EN: { path: 'functions', title: 'Functions' },
  FUNCTIONS_NB: { path: 'funksjoner', title: 'Funksjoner' },
  FUNCTIONS_UA: { path: 'funktsiyi', title: 'Функції' },
  PARENTHESES_EN: { path: 'parentheses', title: 'Parentheses' },
  PARENTHESES_NB: { path: 'parenteser', title: 'Parenteser' },
  PARENTHESES_UA: { path: 'kruhli-duzhky', title: 'Круглі дужки' },
  PERCENT_EN: { path: 'percent', title: 'Percent' },
  PERCENT_NB: { path: 'prosent', title: 'Prosent' },
  PERCENT_UA: { path: 'ponyattya-vidsotka', title: 'Поняття відсотка' },
  POWERS_EN: { path: 'powers', title: 'Powers' },
  POWERS_NB: { path: 'potenser', title: 'Potenser' },
  POWERS_UA: { path: 'stepin-chysla', title: 'Степінь числа' },
  THE_MULTIPLICATION_TABLE_EN: { path: 'the-multiplication-table', title: 'The Multiplication Table' },
  THE_MULTIPLICATION_TABLE_NB: { path: 'gangetabellen', title: 'Gangetabellen' },
  THE_MULTIPLICATION_TABLE_UA: { path: 'tablytsya-mnozhennya', title: 'Таблиця множення' },
}
